import { baseApi } from "./baseApi";
import {
  parseConfirmSignupResponse,
} from "../parsers/auth.parsers";

/**
 * Authentication API service
 * Extends the base API with authentication endpoints
 */
export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Signup
    initiateSignup: builder.mutation({
      query: (payload) => ({
        url: 'api/auth/signup/initiate',
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }),
      invalidatesTags: ['User'],
    })
    ,
    // Confirm Signup
    confirmSignup: builder.mutation({
      query: (payload) => ({
        url: "api/auth/signup/confirm",
        method: "POST",
        body: payload,
      }),
      transformResponse: (response) => {
        return parseConfirmSignupResponse(response);
      },
   
      invalidatesTags: ["User"],
    }),
    // Send OTP
    otpSend: builder.mutation({
      query: (payload) => ({
        url: "api/auth/send-otp",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["User"],
    }),
    // Verify OTP
    verifyOtp: builder.mutation({
      query: (payload) => ({
        url: "api/auth/verify-otp",
        method: "POST",
        body: payload,
      }),
        invalidatesTags: ["User"],
    }),
    // Initiate Login
    initiateLogin: builder.mutation({
      query: (payload) => ({
        url: "api/auth/login/initiate",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["User"],
    }),
    // Confirm Login
    confirmLogin: builder.mutation({
      query: (payload) => ({
        url: "api/auth/login/confirm",
        method: "POST",
        body: payload,
      }),
      transformResponse: (response) => {
        return parseConfirmSignupResponse(response);
      },
     
      invalidatesTags: ["User"],
    }),
    // Logout
    logout: builder.mutation({
      query: () => ({
        url: "api/auth/logout",
        method: "POST",
      }),
      transformResponse: (response) => {
        return {
          success: response?.success !== false,
          message: response?.message || 'Logged out successfully'
        };
      },
   
      invalidatesTags: ["User"],
    }),
    // refresh token
    refreshToken: builder.mutation({
      query: () => ({
        url: "api/auth/refresh-token",
        method: "POST",
      }),
   
      invalidatesTags: ["User"],
    }),
    // Get Customer by Mobile
    getCustomerByMobile: builder.query({
      query: (mobile) => ({
        url: `api/customer/by-mobile?mobile=${mobile}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
    }),
  }),
});
// Export hooks for usage in components
export const {
  useInitiateSignupMutation,
  useConfirmSignupMutation,
  useOtpSendMutation,
  useVerifyOtpMutation,
  useInitiateLoginMutation,
  useConfirmLoginMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
  useLoginMutation, 
  useRegisterMutation, 
  useResendOtpMutation,
  useLazyGetCustomerByMobileQuery,
  useGetCustomerByMobileQuery,
} = authApi;
